import Divider from "@mui/material/Divider";
import Grow from "@mui/material/Grow";
import MenuList from "@mui/material/MenuList";
import Popper from "@mui/material/Popper";
import { memo, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import PersonIcon from "@mui/icons-material/Person";
import { removeLocalStorageSessionData } from "../../auth/AuthFunctions";
import { AuthLogout } from "../../redux/actions/AuthActions";
import { ShowGlobalLoading } from "../../redux/actions/UiActions";
import { CleanUrl } from "../../redux/actions/UrlActions";
import LocalStorageService from "../../services/LocalStorageService";
import { Container, StyledPaper, UserImage, StyledMenuItem } from "./styles/LoggedInMenuStyles";

function LoggedInMenu() {
    const history = useHistory();
    const dispatch = useDispatch();

    const [hover, setHover] = useState(false);
    const [userImage, setUserImage] = useState("");

    const containerRef = useRef(null);

    const handleHovering = (hoverState) => {
        setHover(hoverState);
    };

    const HandleLogOut = () => {
        dispatch(ShowGlobalLoading("Cerrando sesión"));
        setTimeout(() => {
            removeLocalStorageSessionData();
            dispatch(AuthLogout());
            dispatch(CleanUrl());
            window.location.reload();
        }, 1500);
    };

    useEffect(() => {
        setUserImage(LocalStorageService.getItem("profile_img"));
    }, []);

    return (
        <Container ref={containerRef} onMouseOver={() => handleHovering(true)} onMouseOut={() => handleHovering(false)}>
            {userImage ? (
                <UserImage src={userImage} onClick={() => history.push("/app/mi-escritorio")} />
            ) : (
                <div 
                    onClick={() => history.push("/app/mi-escritorio")}
                    style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        backgroundColor: "#E2E8F0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#475569",
                        border: "2px solid #BBC4F8"
                    }}
                >
                    <PersonIcon style={{ fontSize: "20px" }} />
                </div>
            )}
            <Popper open={hover} anchorEl={containerRef.current} role={undefined} placement="bottom-end" transition disablePortal>
                {({ TransitionProps }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: "right top",
                        }}
                    >
                        <StyledPaper>
                            <MenuList style={{ padding: 0 }}>
                                <StyledMenuItem onClick={() => history.push("/app/mi-escritorio")}>Mi Escritorio</StyledMenuItem>
                                <StyledMenuItem onClick={() => history.push("/app/mi-cuenta/perfil")}>Mi Perfil</StyledMenuItem>
                                <StyledMenuItem onClick={() => history.push("/app/documentos")}>Mis Documentos</StyledMenuItem>
                                <Divider sx={{ margin: 0, borderColor: "#E2E8F0" }} />
                                <StyledMenuItem onClick={HandleLogOut}>Cerrar sesión</StyledMenuItem>
                            </MenuList>
                        </StyledPaper>
                    </Grow>
                )}
            </Popper>
        </Container>
    );
}

export default memo(LoggedInMenu);
